// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--2b30a";
export var logo = "footer-module--logo--9d138";
export var nav = "footer-module--nav--36612";
export var navItem = "footer-module--navItem--bca14";
export var outer = "footer-module--outer--3ff28";
export var support = "footer-module--support--899cd";
export var supportLabel = "footer-module--supportLabel--4d3ab";
export var supportLink = "footer-module--supportLink--15240";